import React from 'react';

export type PremiumIconProps = {
    size?: number;
    className?: string;
    color?: string;
};

function strokeProps(color?: string) {
    return {
        stroke: color ?? 'currentColor',
        strokeLinecap: 'round' as const,
        strokeLinejoin: 'round' as const,
        fill: 'none' as const,
    };
}

// node-id=21043:14972
export const PremiumTrendUpIcon: React.FC<PremiumIconProps> = ({ size = 20, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 12.2L8 7.7L11 10.7L16.5 5.2" strokeWidth="1.67" {...strokeProps(color)} />
        <path d="M12.8 5.2H16.5V8.9" strokeWidth="1.67" {...strokeProps(color)} />
    </svg>
);

// node-id=21043:14982
export const PremiumLocationPinIcon: React.FC<PremiumIconProps> = ({ size = 20, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" className={className} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 18c0 0 6-5.47 6-10a6 6 0 1 0-12 0c0 4.53 6 10 6 10Z"
            strokeWidth="1.67"
            {...strokeProps(color)}
        />
        <circle cx="10" cy="8" r="2" strokeWidth="1.67" {...strokeProps(color)} />
    </svg>
);

// node-id=21043:14992
export const PremiumMedalIcon: React.FC<PremiumIconProps> = ({ size = 20, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" className={className} xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="7.75" r="4.25" strokeWidth="1.67" {...strokeProps(color)} />
        <path d="M7.25 11.4L6 18l4-2.25L14 18l-1.25-6.6" strokeWidth="1.67" {...strokeProps(color)} />
        <path d="M10 5.75l.62 1.26 1.39.2-1 1 .24 1.38L10 8.9l-1.25.69.24-1.38-1-1 1.39-.2L10 5.75Z" strokeWidth="1.1" {...strokeProps(color)} />
    </svg>
);

// node-id=21043:15001
export const PremiumChevronDownIcon: React.FC<PremiumIconProps> = ({ size = 20, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 8l4.5 4.5L14.5 8" strokeWidth="1.67" {...strokeProps(color)} />
    </svg>
);

// node-id=21079:3685
export const PremiumInfoCircleIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6.67" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M8 7.2V11" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M8 5.25h.01" strokeWidth="2" {...strokeProps(color)} />
    </svg>
);

// node-id=21083:13464
export const PremiumArrowUpIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M8 13V3" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M4.8 6.2L8 3l3.2 3.2" strokeWidth="1.33" {...strokeProps(color)} />
    </svg>
);

// node-id=21083:13468
export const PremiumArrowDownIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3v10" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M4.8 9.8 8 13l3.2-3.2" strokeWidth="1.33" {...strokeProps(color)} />
    </svg>
);

// node-id=21082:13427
export const PremiumSwapIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5h9" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M10.6 3.6 12 5l-1.4 1.4" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M13 11H4" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M5.4 9.6 4 11l1.4 1.4" strokeWidth="1.33" {...strokeProps(color)} />
    </svg>
);

// node-id=21079:3732
export const PremiumUserIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="5.33" r="2.33" strokeWidth="1.33" {...strokeProps(color)} />
        <path d="M3.5 13c.9-2.1 2.7-3.2 4.5-3.2S11.6 10.9 12.5 13" strokeWidth="1.33" {...strokeProps(color)} />
    </svg>
);

// node-id=21083:13453
export const PremiumMinusIcon: React.FC<PremiumIconProps> = ({ size = 16, className, color }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8h8" strokeWidth="1.33" {...strokeProps(color)} />
    </svg>
);

